import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'

import { url_rest, types } from 'configuration'
import { getRequest, postRequest } from 'services/ApiService.js'
import Layout from 'components/Layout.jsx';



class MunicipalityType extends Component {
  state = {}

  constructor(props) {
    super(props);

    this.state = {
      type_list: []
    }
    this.apiCall()

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.apiCall()
    }
  }

  apiCall() {
    var promises = []

    this.setState({ type_list: [] })

    promises.push(postRequest(url_rest + "/territory/paginated", {
      "item_number": 0,
      "page_size": 20,
      "filters": {
        "slug": this.props.match.params.slug
      }
    }, this.props.match.params.lang))
    promises.push(postRequest(url_rest + "/resource_type/paginated", {
      "item_number": 0,
      "page_size": 20,
      "filters": {
        "slug": this.props.match.params.type
      }
    }, this.props.match.params.lang))

    Promise.all(promises).then(responses => {
      this.setState({ type_name: responses[1].data.list[0].name, type_code: responses[1].data.list[0].code })
      postRequest(url_rest + "/resource/paginated", {
        "item_number": 0,
        "page_size": 20,
        "filters": {
          "territories.id": responses[0].data.list[0].id,
          "resource_type.id": responses[1].data.list[0].id,
          "resource_state_history.resource_state.code":"ESTREPUBLICADO",
          "resource_state_history.current":true
        }
      }, this.props.match.params.lang).then(
        response => {
          var resource_list = []
          var promises = []
          for (let i = 0; i < response.data.list.length; i++) {
            promises.push(getRequest(url_rest + "/resource/get/" + response.data.list[i].id, this.props.match.params.lang))
          }
          Promise.all(promises).then(responses => responses.map(
            response => resource_list.push(response.data)
          ).then(
            this.setState({ type_list: resource_list })
          )
          )
        }
      )
    })
  }

  printlist = () => {
    var icon = ''
    if (this.state.type_code) {
      icon = types[this.state.type_code].icon
    }
    var result = []
    for (let i = 0; i < this.state.type_list.length; i++) {
        var web = ''
      var phone = ''
      var address = ''
      if (this.state.type_list[i].contact_information) {
        if (this.state.type_list[i].contact_information[0].web) {
          web = <p><i className="fas fa-link fa-1x"></i>{this.state.type_list[i].contact_information[0].web}</p>
        }
        if (this.state.type_list[i].contact_information[0].first_phone_number) {
          phone = <p><i className="fas fa-phone fa-1x"></i>{this.state.type_list[i].contact_information[0].first_phone_number}</p>
        }
      }

      if (this.state.type_list[i].address_number && this.state.type_list[i].vial_name) {
        address = <p><i className="fas fa-map-marker-alt fa-1x"></i>{this.state.type_list[i].address_number + ', ' + this.state.type_list[i].vial_name}</p>
      }
      var image = ""

      if (this.state.type_list[i].image) {
        image = <img className="profile-card" src={this.state.type_list[i].image}></img>
      } else {
        image = <div className="profile-card"><i className={"fas " + icon + " fa-4x"}></i></div>
      }
      result.push(
        <div onClick={(e) => {this.props.history.push(this.props.history.location.pathname.replace(/\/$/,'')+"/"+this.state.type_list[i].slug)/*"/" + this.props.match.params.lang + "/destinos/" + this.props.match.params.slug + "/" + this.props.match.params.type + "/" + this.state.type_list[i].slug*/}} className="card-lvl-2">
          <div className="card-wrapper">
            {image}
            <div className="info">
              <div className="general">
                <h2>{this.state.type_list[i].name}</h2>
                <hr />
                <div className="building">
                  {address}
                  {phone}
                  {web}
                </div>
              </div>
            </div>
          </div>
        </div>)
      
    }
    return result
  }

  render() {
    return (
      <Layout contentType="destinos" queryTerm={this.props.match.params.slug} queryType={this.props.match.params.type} lang={this.props.match.params.lang}>
        <div className="content-lvl-2 cards-lvl-2-content page-title"><h1>{this.state.type_name}</h1></div>
        <div className="content-lvl-2 cards-lvl-2-content">
          {this.printlist()}
        </div>
      </Layout>
    )
  }
}

export default withRouter(MunicipalityType)


// WEBPACK FOOTER //
// ./src/pages/MunicipalityType.js